import { ProductVariantTable } from "~/features/productDetails/components/DataTables/ProductVariantTable";
import { CharacteristicsIcons } from "~/features/productDetails/components/DataTables/CharacteristicsIcons";
import { Card } from "~/features/configurator/Linear/components/Card";
import PdfDownloadLink from "~/features/productDetails/components/SpecificationsCard/components/PdfDownloadLink";
import { type PdpPageProductData } from "~/features/productDetails/models/PdpPageProductData";
import { Col, Row } from "~/common/components/Layout";
import BearingXPdfDownloadLink from "~/features/productDetails/components/SpecificationsCard/components/BearingXPdfDownloadLink";
import useMediaQuery from "~/common/hooks/useMediaQuery";
import RohsPdfDownloadLink from "~/features/productDetails/components/SpecificationsCard/components/RohsPdfDownloadLink";
import { MEDIA_QUERY_MIN_DESKTOP_S } from "~/common/utils/screenSizes";
import { useTranslation } from "react-i18next";

interface Props {
  product: PdpPageProductData;
}

export const SpecificationsCard = ({ product }: Props) => {
  const isDesktop = useMediaQuery(MEDIA_QUERY_MIN_DESKTOP_S);
  const { t } = useTranslation();

  return (
    <Card className={"scha__pdp__specifications-card"} disableHover={true}>
      <Row>
        <Col size={12} className={"scha__pdp__download-title"}>
          {t("productDetailPage.downloads.title")}
        </Col>
        <Col size={12} className={isDesktop ? "pt-2" : ""}>
          <PdfDownloadLink product={product} />
        </Col>
        {product.showBasicFrequencies && product.bearingXDesignation && (
          <Col size={12} className={isDesktop ? "pt-2" : ""}>
            <BearingXPdfDownloadLink product={product} bearingXDesignation={product.bearingXDesignation} />
          </Col>
        )}
        {product.showRohsDownload && (
          <Col size={12} className={isDesktop ? "pt-2" : ""}>
            <RohsPdfDownloadLink product={product} />
          </Col>
        )}
      </Row>
      {product.specificationBand && product.specificationBand.length > 0 && (
        <ProductVariantTable data={product.specificationBand} />
      )}
      {product.attributeIcons && product.attributeIcons.length > 0 && (
        <CharacteristicsIcons data={product.attributeIcons} />
      )}
    </Card>
  );
};
